import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { cn } from '@/lib/utils';

interface OTPVerifyFormProps {
    otpCode: string;
    onOtpChange: (value: string) => void;
    onResendCode: () => void;
    countdown: number;
    isSendingCode: boolean;
    isDrawer?: boolean;
}

export const OTPVerifyForm: React.FC<OTPVerifyFormProps> = ({
    otpCode,
    onOtpChange,
    onResendCode,
    countdown,
    isSendingCode,
    isDrawer
}) => {
    return (
        <div className={cn("space-y-4", isDrawer ? "px-4" : "")} dir="rtl">
            <div className="space-y-2">
                <Label htmlFor="otpCode">קוד אימות</Label>
                <Input
                    id="otpCode"
                    name="otpCode"
                    type="text"
                    value={otpCode}
                    onChange={(e) => {
                        const val = e.target.value.replace(/\D/g, '').slice(0, 6);
                        onOtpChange(val);
                    }}
                    placeholder="000000"
                    required
                    className="text-center text-2xl tracking-widest"
                    dir="ltr"
                    maxLength={6}
                    autoFocus={false}
                />
            </div>
            <div className="text-center text-sm text-muted-foreground mt-4">
                לא קיבלת קוד?{' '}
                <Button
                    type="button"
                    variant="link"
                    onClick={onResendCode}
                    disabled={countdown > 0 || isSendingCode}
                    className="p-0 h-auto text-sm"
                >
                    {countdown > 0 ? `שלח שוב בעוד ${countdown} שניות` : 'שלח שוב'}
                </Button>
            </div>
        </div>
    );
};
